import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { useParams } from 'src/routes/hooks';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import BarDispatchOrderEditView from 'src/sections/bar-dispatches/view/bar-dispatch-edit-view';

export default function BarDispatchOrderEditPage() {
  const params = useParams();

  const { user: authUser } = useAuthContext();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title>Edit bar dispatch order</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_BAR_INVENTORY_TRANSACTION,
        AuthPermissions.UPDATE_BAR_INVENTORY_TRANSACTION,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <BarDispatchOrderEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
